import React from "react";
import { Pie } from "react-chartjs-2";
import MainCardOne from "../Cards/MainCardOne";

import MainCardThree from "../Cards/MainCardThree";

export const CardCompthree = ({}) => {
  return (
    <div className=" p-2 pb-3 px-0" >
       <h6 className="fw-bold px-1 mt-2 text-dark pb-1">
          Number of
        </h6>
      <div className="card light-shadow border-orange mb-0 n_shadow a_card">
      <div className="col-6 col-md-7 col-lg-12 mb-xl-0 align-self-center align-items-center">
     
      </div>
        <div className="row bg-white">
          <div className="col-12 col-lg-3 text-center ">
            <a className="card-body"  >
              <div className="stats">
                  <div className="">
                    <h2 className='text-dark'>346</h2>
                  </div>
                  <span className="icon">
                    {/* <img src="./assets/img/approved.png" style={{ height: "40px", marginTop: "-10px" }} /> */}
                  </span>
                <p className="green" style={{ fontWeight: "600", marginBottom: "-7px" }}>Sites Visited</p>
              </div>
            </a>
          </div>
          <div className="col-12 col-lg-3 text-center ">
            <a className="card-body"  >
              <div className="stats">
                  <div className=''>
                    <h2 className='text-dark'>346</h2>
                  </div>
                  <span className="icon">
                    {/* <img src="./assets/img/approved.png" style={{ height: "40px", marginTop: "-10px" }} /> */}
                  </span>
                <p className="green" style={{ fontWeight: "600", marginBottom: "-7px" }}>Beneficiaries Covered</p>
              </div>
            </a>
          </div>
          <div className="col-12 col-lg-3 text-center ">
            <a className="card-body"  >
              <div className="stats">
                  <div className=''>
                    <h2 className='text-dark'>346</h2>
                  </div>
                  <span className="icon">
                    {/* <img src="./assets/img/approved.png" style={{ height: "40px", marginTop: "-10px" }} /> */}
                  </span>
                <p className="green" style={{ fontWeight: "600", marginBottom: "-7px" }}>Beneficiaries Left</p>
              </div>
            </a>
          </div>
          <div className="col-12 col-lg-3 text-center">
            <a className="card-body"  >
              <div className="stats">
                  <div className=''>
                    <h2 className=' text-dark'>346</h2>
                  </div>
                  <span className="icon">
                    {/* <img src="./assets/img/approved.png" style={{ height: "40px", marginTop: "-10px" }} /> */}
                  </span>
                <p className="green" style={{ fontWeight: "600", marginBottom: "-7px" }}>Covered and Left Area</p>
              </div>
            </a>
          </div>

        </div>
      </div>
    </div>
  );
};
